import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const ai = new ApplicationInsights({
  config: {
    instrumentationKey: "3f159286-665d-4fa6-a7fc-976b280a091c",
    autoTrackPageVisitTime: true,
    enableAutoRouteTracking: true,
  },
});

ai.loadAppInsights();
ai.trackPageView();
export const appInsights = ai;
